import { Asterisk } from 'lucide-react';

export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? 'bg-brand-deep border-white/10 text-brand-light' : 'bg-brand-pale border-border text-brand-dark'}`}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-heading text-lg md:text-xl font-medium tracking-wide whitespace-nowrap">
                <span className="px-6">{item}</span>
                <Asterisk className="h-5 w-5 opacity-60" strokeWidth={1.5} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
